import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 15c.345 .6 1.258 1 2 1a2 2 0 1 0 0 -4a2 2 0 1 1 0 -4c.746 0 1.656 .394 2 1","key":"svg-0"}],["path",{"d":"M21 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0","key":"svg-1"}],["path",{"d":"M14 8h-4v8h4","key":"svg-2"}],["path",{"d":"M10 12h2.5","key":"svg-3"}]]

const IconMathSec = createReactComponent('outline', 'math-sec', 'MathSec', __iconNode);

export default IconMathSec;